module.exports = __webpack_public_path__ + "f9afc8a02a6d0732f7322add418267a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201509_waz.jpg
// module id = 639
// module chunks = 0